// BEANS
import beanCharroImg from "../assets/products/beans/CHARRO_BEANS/CHARRO_BEANS.png"
import beanCharroImg2 from "../assets/products/beans/CHARRO_BEANS/CHARRO_BEANS_BACK.png"
import beanCharroImg3 from "../assets/products/beans/CHARRO_BEANS/CHARRO_BEANS_PACK.png"
import beanCharroImg4 from "../assets/products/beans/CHARRO_BEANS/CHARRO_BEANS_NFACTS.png"
import beanCharroImg5 from "../assets/products/beans/CHARRO_BEANS/CHARRO_BEANS_POST.png"
import beanMexicanBlackImg from "../assets/products/beans/MEXICAN_BLACK_BEANS/MEXICAN_BLACK_BEANS.png"
import beanMexicanBlackImg2 from "../assets/products/beans/MEXICAN_BLACK_BEANS/MEXICAN_BLACK_BEANS_BACK.png"
import beanMexicanBlackImg3 from "../assets/products/beans/MEXICAN_BLACK_BEANS/MEXICAN_BLACK_BEANS_PACK.png"
import beanMexicanBlackImg4 from "../assets/products/beans/MEXICAN_BLACK_BEANS/MEXICAN_BLACK_BEANS_NFACTS.png"
import beanMexicanBlackImg5 from "../assets/products/beans/MEXICAN_BLACK_BEANS/MEXICAN_BLACK_BEANS_POST.png"
import beanEloteImg from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS.png";
import beanEloteImg2 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS_BACK.png";
import beanEloteImg3 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_PACK.png";
import beanEloteImg4 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_NFACTS.png";
import beanEloteImg5 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_POST.png";
import beanRefriedPintoImg from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/REFRIED_PINTO_BEANS_JALAPENO.png"
import beanRefriedPintoImg2 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/REFRIED_PINTO_BEANS_JALAPENO_BACK.png"
import beanRefriedPintoImg3 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/REFRIED_PINTO_BEANS_JALAPENO_PACK.png"
import beanRefriedPintoImg4 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/REFRIED_PINTO_BEANS_JALAPENO_NFACTS.png"
import beanRefriedPintoImg5 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/REFRIED_PINTO_BEANS_JALAPENO_POST.png"
import beanRefriedRancheroImg from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/REFRIED_RANCHERO_BEANS_CHIPOTLE.png"
import beanRefriedRancheroImg2 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/REFRIED_RANCHERO_BEANS_CHIPOTLE_BACK.png"
import beanRefriedRancheroImg3 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/REFRIED_RANCHERO_BEANS_CHIPOTLE_PACK.png"
import beanRefriedRancheroImg4 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/REFRIED_RANCHERO_BEANS_CHIPOTLE_NFACTS.png"
import beanRefriedRancheroImg5 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/REFRIED_RANCHERO_BEANS_CHIPOTLE_POST.png"

// BEANS CLAIMS
import beanCharroClaim1 from "../assets/products/beans/CHARRO_BEANS/Claims/NON_GMO_VERIFIED.png"
import beanCharroClaim2 from "../assets/products/beans/CHARRO_BEANS/Claims/AVOCADO_OIL.png"
import beanCharroClaim3 from "../assets/products/beans/CHARRO_BEANS/Claims/HIGH_FIBER.png"
import beanCharroClaim4 from "../assets/products/beans/CHARRO_BEANS/Claims/READY_IN_SECONDS.png"
import beanMexicanBlackClaim1 from "../assets/products/beans/MEXICAN_BLACK_BEANS/Claims/NON_GMO_VERIFIED.png"
import beanMexicanBlackClaim2 from "../assets/products/beans/MEXICAN_BLACK_BEANS/Claims/AVOCADO_OIL.png"
import beanMexicanBlackClaim3 from "../assets/products/beans/MEXICAN_BLACK_BEANS/Claims/HIGH_FIBER.png"
import beanMexicanBlackClaim4 from "../assets/products/beans/MEXICAN_BLACK_BEANS/Claims/READY_IN_SECONDS.png"
import beanEloteClaim1 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/Claims/NON_GMO_VERIFIED.png";
import beanEloteClaim2 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/Claims/AVOCADO_OIL.png";
import beanEloteClaim3 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/Claims/HIGH_FIBER.png";
import beanEloteClaim4 from "../assets/products/beans/MEXICAN_ELOTE_STYLE_PINTO_AND_BLACK_BEANS/Claims/READY_IN_SECONDS.png";
import beanRefriedPintoClaim1 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/Claims/NON_GMO_VERIFIED.png"
import beanRefriedPintoClaim2 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/Claims/AVOCADO_OIL.png"
import beanRefriedPintoClaim3 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/Claims/HIGH_FIBER.png"
import beanRefriedPintoClaim4 from "../assets/products/beans/REFRIED_PINTO_BEANS_JALAPENO/Claims/READY_IN_SECONDS.png"
import beanRefriedRancheroClaim1 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/Claims/NON_GMO_VERIFIED.png"
import beanRefriedRancheroClaim2 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/Claims/AVOCADO_OIL.png"
import beanRefriedRancheroClaim3 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/Claims/HIGH_FIBER.png"
import beanRefriedRancheroClaim4 from "../assets/products/beans/REFRIED_RANCHERO_BEANS_CHIPOTLE/Claims/READY_IN_SECONDS.png"

// RICE CUPS
import riceCupMexicanHomestyleImg from "../assets/products/rices/cups/MEXICAN_HOMESTYLE_RED_RICE_CUP/MEXICAN_HOMESTYLE_RED_RICE_CUP.png"
import riceCupMexicanHomestyleImg2 from "../assets/products/rices/cups/MEXICAN_HOMESTYLE_RED_RICE_CUP/MEXICAN_HOMESTYLE_RED_RICE_CUP_NFACTS.png"
import riceCupMexicanHomestyleImg3 from "../assets/products/rices/cups/MEXICAN_HOMESTYLE_RED_RICE_CUP/MEXICAN_HOMESTYLE_RED_RICE_CUP_POST.png"
import riceCupMexicanPolloAsadoImg from "../assets/products/rices/cups/MEXICAN_POLLO_ASADO_RICE_CUP/MEXICAN_POLLO_ASADO_RICE_CUP.png"
import riceCupMexicanPolloAsadoImg2 from "../assets/products/rices/cups/MEXICAN_POLLO_ASADO_RICE_CUP/MEXICAN_POLLO_ASADO_RICE_CUP_NFACTS.png"
import riceCupMexicanPolloAsadoImg3 from "../assets/products/rices/cups/MEXICAN_POLLO_ASADO_RICE_CUP/MEXICAN_POLLO_ASADO_RICE_CUP_POST.png"
import riceCupMexicanStreetCornImg from "../assets/products/rices/cups/MEXICAN_STREET_CORN_RICE_CUP/MEXICAN_STREET_CORN_RICE_CUP.png"
import riceCupMexicanStreetCornImg2 from "../assets/products/rices/cups/MEXICAN_STREET_CORN_RICE_CUP/MEXICAN_STREET_CORN_RICE_CUP_NFACTS.png"
import riceCupMexicanStreetCornImg3 from "../assets/products/rices/cups/MEXICAN_STREET_CORN_RICE_CUP/MEXICAN_STREET_CORN_RICE_CUP_POST.png"
import riceCupPeppersChipotleImg from "../assets/products/rices/cups/PEPPERS_AND_CHIPOTLE_RICE_CUP/PEPPERS_AND_CHIPOTLE_RICE_CUP.png"
import riceCupPeppersChipotleImg2 from "../assets/products/rices/cups/PEPPERS_AND_CHIPOTLE_RICE_CUP/PEPPERS_AND_CHIPOTLE_RICE_CUP_NFACTS.png"
import riceCupPeppersChipotleImg3 from "../assets/products/rices/cups/PEPPERS_AND_CHIPOTLE_RICE_CUP/PEPPERS_AND_CHIPOTLE_RICE_CUP_POST.png"
import riceCupPoblanoImg from "../assets/products/rices/cups/POBLANO_RICE_CUP/POBLANO_RICE_CUP.png"
import riceCupPoblanoImg2 from "../assets/products/rices/cups/POBLANO_RICE_CUP/POBLANO_RICE_CUP_NFACTS.png"
import riceCupPoblanoImg3 from "../assets/products/rices/cups/POBLANO_RICE_CUP/POBLANO_RICE_CUP_POST.png"

// RICE CUPS CLAIMS
import riceCupMexicanHomestyleClaim1 from "../assets/products/rices/cups/MEXICAN_HOMESTYLE_RED_RICE_CUP/Claims/BONE_BROTH.png"
import riceCupMexicanHomestyleClaim2 from "../assets/products/rices/cups/MEXICAN_HOMESTYLE_RED_RICE_CUP/Claims/AVOCADO_OIL.png"
import riceCupMexicanHomestyleClaim3 from "../assets/products/rices/cups/MEXICAN_HOMESTYLE_RED_RICE_CUP/Claims/PANTRY_STABLE.png"
import riceCupMexicanHomestyleClaim4 from "../assets/products/rices/cups/MEXICAN_HOMESTYLE_RED_RICE_CUP/Claims/READY_IN_SECONDS.png"
import riceCupMexicanPolloAsadoClaim1 from "../assets/products/rices/cups/MEXICAN_POLLO_ASADO_RICE_CUP/Claims/BONE_BROTH.png"
import riceCupMexicanPolloAsadoClaim2 from "../assets/products/rices/cups/MEXICAN_POLLO_ASADO_RICE_CUP/Claims/AVOCADO_OIL.png"
import riceCupMexicanPolloAsadoClaim3 from "../assets/products/rices/cups/MEXICAN_POLLO_ASADO_RICE_CUP/Claims/PANTRY_STABLE.png"
import riceCupMexicanPolloAsadoClaim4 from "../assets/products/rices/cups/MEXICAN_POLLO_ASADO_RICE_CUP/Claims/READY_IN_SECONDS.png"
import riceCupMexicanStreetCornClaim1 from "../assets/products/rices/cups/MEXICAN_STREET_CORN_RICE_CUP/Claims/BONE_BROTH.png"
import riceCupMexicanStreetCornClaim2 from "../assets/products/rices/cups/MEXICAN_STREET_CORN_RICE_CUP/Claims/AVOCADO_OIL.png"
import riceCupMexicanStreetCornClaim3 from "../assets/products/rices/cups/MEXICAN_STREET_CORN_RICE_CUP/Claims/PANTRY_STABLE.png"
import riceCupMexicanStreetCornClaim4 from "../assets/products/rices/cups/MEXICAN_STREET_CORN_RICE_CUP/Claims/READY_IN_SECONDS.png"
import riceCupPeppersChipotleClaim1 from "../assets/products/rices/cups/PEPPERS_AND_CHIPOTLE_RICE_CUP/Claims/BONE_BROTH.png"
import riceCupPeppersChipotleClaim2 from "../assets/products/rices/cups/PEPPERS_AND_CHIPOTLE_RICE_CUP/Claims/AVOCADO_OIL.png"
import riceCupPeppersChipotleClaim3 from "../assets/products/rices/cups/PEPPERS_AND_CHIPOTLE_RICE_CUP/Claims/PANTRY_STABLE.png"
import riceCupPeppersChipotleClaim4 from "../assets/products/rices/cups/PEPPERS_AND_CHIPOTLE_RICE_CUP/Claims/READY_IN_SECONDS.png"
import riceCupPoblanoClaim1 from "../assets/products/rices/cups/POBLANO_RICE_CUP/Claims/BONE_BROTH.png"
import riceCupPoblanoClaim2 from "../assets/products/rices/cups/POBLANO_RICE_CUP/Claims/AVOCADO_OIL.png"
import riceCupPoblanoClaim3 from "../assets/products/rices/cups/POBLANO_RICE_CUP/Claims/PANTRY_STABLE.png"
import riceCupPoblanoClaim4 from "../assets/products/rices/cups/POBLANO_RICE_CUP/Claims/READY_IN_SECONDS.png"

// RICE POUCHES
import ricePouchMexicanHomestyleImg from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/MEXICAN_HOMESTYLE_RED_RICE.png";
import ricePouchMexicanHomestyleImg2 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/MEXICAN_HOMESTYLE_RED_RICE_BACK.png";
import ricePouchMexicanHomestyleImg3 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/MEXICAN_HOMESTYLE_RED_RICE_PACK.png";
import ricePouchMexicanHomestyleImg4 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/MEXICAN_HOMESTYLE_RED_RICE_NFACTS.png";
import ricePouchMexicanHomestyleImg5 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/MEXICAN_HOMESTYLE_RED_RICE_POST.png";
import ricePouchMexicanPolloAsadoImg from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/MEXICAN_POLLO_ASADO_RICE.png";
import ricePouchMexicanPolloAsadoImg2 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/MEXICAN_POLLO_ASADO_RICE_BACK.png";
import ricePouchMexicanPolloAsadoImg3 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/MEXICAN_POLLO_ASADO_RICE_PACK.png";
import ricePouchMexicanPolloAsadoImg4 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/MEXICAN_POLLO_ASADO_RICE_NFACTS.png";
import ricePouchMexicanPolloAsadoImg5 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/MEXICAN_POLLO_ASADO_RICE_POST.png";
import ricePouchMexicanStreetCornImg from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/MEXICAN_STREET_CORN_RICE.png";
import ricePouchMexicanStreetCornImg2 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/MEXICAN_STREET_CORN_RICE_BACK.png";
import ricePouchMexicanStreetCornImg3 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/MEXICAN_STREET_CORN_RICE_PACK.png";
import ricePouchMexicanStreetCornImg4 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/MEXICAN_STREET_CORN_RICE_NFACTS.png";
import ricePouchMexicanStreetCornImg5 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/MEXICAN_STREET_CORN_RICE_POST.png";
import ricePouchPeppersChipotleImg from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/PEPPERS_AND_CHIPOTLE_RICE.png";
import ricePouchPeppersChipotleImg2 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/PEPPERS_AND_CHIPOTLE_RICE_BACK.png";
import ricePouchPeppersChipotleImg3 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/PEPPERS_AND_CHIPOTLE_RICE_PACK.png";
import ricePouchPeppersChipotleImg4 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/PEPPERS_AND_CHIPOTLE_RICE_NFACTS.png";
import ricePouchPeppersChipotleImg5 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/PEPPERS_AND_CHIPOTLE_RICE_POST.png";
import ricePouchPoblanoImg from "../assets/products/rices/pouches/POBLANO_RICE/POBLANO_RICE.png";
import ricePouchPoblanoImg2 from "../assets/products/rices/pouches/POBLANO_RICE/POBLANO_RICE_BACK.png";
import ricePouchPoblanoImg3 from "../assets/products/rices/pouches/POBLANO_RICE/POBLANO_RICE_PACK.png";
import ricePouchPoblanoImg4 from "../assets/products/rices/pouches/POBLANO_RICE/POBLANO_RICE_NFACTS.png";
import ricePouchPoblanoImg5 from "../assets/products/rices/pouches/POBLANO_RICE/POBLANO_RICE_POST.png";

// RICE POUCHES CLAIMS
import ricePouchMexicanHomestyleClaim1 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/Claims/BONE_BROTH.png";
import ricePouchMexicanHomestyleClaim2 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/Claims/AVOCADO_OIL.png";
import ricePouchMexicanHomestyleClaim3 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/Claims/PANTRY_STABLE.png";
import ricePouchMexicanHomestyleClaim4 from "../assets/products/rices/pouches/MEXICAN_HOMESTYLE_RED_RICE/Claims/READY_IN_SECONDS.png";
import ricePouchMexicanPolloAsadoClaim1 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/Claims/BONE_BROTH.png";
import ricePouchMexicanPolloAsadoClaim2 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/Claims/AVOCADO_OIL.png";
import ricePouchMexicanPolloAsadoClaim3 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/Claims/PANTRY_STABLE.png";
import ricePouchMexicanPolloAsadoClaim4 from "../assets/products/rices/pouches/MEXICAN_POLLO_ASADO_RICE/Claims/READY_IN_SECONDS.png";
import ricePouchMexicanStreetCornClaim1 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/Claims/BONE_BROTH.png";
import ricePouchMexicanStreetCornClaim2 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/Claims/AVOCADO_OIL.png";
import ricePouchMexicanStreetCornClaim3 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/Claims/PANTRY_STABLE.png";
import ricePouchMexicanStreetCornClaim4 from "../assets/products/rices/pouches/MEXICAN_STREET_CORN_RICE/Claims/READY_IN_SECONDS.png";
import ricePouchPeppersChipotleClaim1 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/Claims/BONE_BROTH.png";
import ricePouchPeppersChipotleClaim2 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/Claims/AVOCADO_OIL.png";
import ricePouchPeppersChipotleClaim3 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/Claims/PANTRY_STABLE.png";
import ricePouchPeppersChipotleClaim4 from "../assets/products/rices/pouches/PEPPERS_AND_CHIPOTLE_RICE/Claims/READY_IN_SECONDS.png";
import ricePouchPoblanoClaim1 from "../assets/products/rices/pouches/POBLANO_RICE/Claims/BONE_BROTH.png";
import ricePouchPoblanoClaim2 from "../assets/products/rices/pouches/POBLANO_RICE/Claims/AVOCADO_OIL.png";
import ricePouchPoblanoClaim3 from "../assets/products/rices/pouches/POBLANO_RICE/Claims/PANTRY_STABLE.png";
import ricePouchPoblanoClaim4 from "../assets/products/rices/pouches/POBLANO_RICE/Claims/READY_IN_SECONDS.png";

// TAMALES
import tamaleGreenSalsa from "../assets/products/tamales/GREEN_SALSA_TAMALE/GREEN_SALSA_TAMALE.png";
import tamaleGreenSalsa2 from "../assets/products/tamales/GREEN_SALSA_TAMALE/GREEN_SALSA_TAMALE_BACK.png";
import tamaleGreenSalsa3 from "../assets/products/tamales/GREEN_SALSA_TAMALE/GREEN_SALSA_TAMALE_PACK.png";
import tamaleGreenSalsa4 from "../assets/products/tamales/GREEN_SALSA_TAMALE/GREEN_SALSA_TAMALE_NFACTS.png";
import tamaleGreenSalsa5 from "../assets/products/tamales/GREEN_SALSA_TAMALE/GREEN_SALSA_TAMALE_POST.png";
import tamaleStreetCorn from "../assets/products/tamales/STREET_CORN_TAMALE/STREET_CORN_TAMALE.png";
import tamaleStreetCorn2 from "../assets/products/tamales/STREET_CORN_TAMALE/STREET_CORN_TAMALE_BACK.png";
import tamaleStreetCorn3 from "../assets/products/tamales/STREET_CORN_TAMALE/STREET_CORN_TAMALE_PACK.png";
import tamaleStreetCorn4 from "../assets/products/tamales/STREET_CORN_TAMALE/STREET_CORN_TAMALE_NFACTS.png";
import tamaleStreetCorn5 from "../assets/products/tamales/STREET_CORN_TAMALE/STREET_CORN_TAMALE_POST.png";
import tamaleRedSalsa from "../assets/products/tamales/RED_SALSA_TAMALE/TAMALE_RED_SALSA.png";
import tamaleRedSalsa2 from "../assets/products/tamales/RED_SALSA_TAMALE/TAMALE_RED_SALSA_BACK.png";
import tamaleRedSalsa3 from "../assets/products/tamales/RED_SALSA_TAMALE/TAMALE_RED_SALSA_PACK.png";
import tamaleRedSalsa4 from "../assets/products/tamales/RED_SALSA_TAMALE/TAMALE_RED_SALSA_NFACTS.png";
import tamaleRedSalsa5 from "../assets/products/tamales/RED_SALSA_TAMALE/TAMALE_RED_SALSA_POST.png";

// TAMALES CLAIMS
import tamaleGreenSalsaClaim1 from "../assets/products/tamales/GREEN_SALSA_TAMALE/Claims/HIGH_PROTEIN.png";
import tamaleGreenSalsaClaim2 from "../assets/products/tamales/GREEN_SALSA_TAMALE/Claims/BEEF_TALLOW.png";
import tamaleGreenSalsaClaim3 from "../assets/products/tamales/GREEN_SALSA_TAMALE/Claims/READY_IN_SECONDS.png";
import tamaleStreetCornClaim1 from "../assets/products/tamales/STREET_CORN_TAMALE/Claims/SEED_OIL_FREE.png";
import tamaleStreetCornClaim2 from "../assets/products/tamales/STREET_CORN_TAMALE/Claims/BEEF_TALLOW.png";
import tamaleStreetCornClaim3 from "../assets/products/tamales/STREET_CORN_TAMALE/Claims/READY_IN_SECONDS.png";
import tamaleRedSalsaClaim1 from "../assets/products/tamales/RED_SALSA_TAMALE/Claims/HIGH_PROTEIN.png";
import tamaleRedSalsaClaim2 from "../assets/products/tamales/RED_SALSA_TAMALE/Claims/BEEF_TALLOW.png";
import tamaleRedSalsaClaim3 from "../assets/products/tamales/RED_SALSA_TAMALE/Claims/READY_IN_SECONDS.png";


export const PRODUCT_CATEGORIES = {
    BEANS: "beans",
    RICE_CUPS: "riceCups",
    RICE_POUCH: "ricePouch",
    TAMALES: "tamales",
};

export const PRODUCTS = [
    // BEANS
    {
        id: "bean_charro",
        name: "Charro Beans",
        category: PRODUCT_CATEGORIES.BEANS,
        description: "Smoky, hearty charro beans loaded with real chorizo flavor.",
        price: "$29.99",
        imageSrc: beanCharroImg,
        imageAlt: "Charro Beans",
        backgroundColor: "#7F1535",
        backgroundDesign: 3,
        images: [
            beanCharroImg3,
            beanCharroImg,
            beanCharroImg2,
            beanCharroImg4,
            beanCharroImg5,
        ],
        claims: [
            { src: beanCharroClaim1, alt: "Non-GMO Verified" },
            { src: beanCharroClaim2, alt: "Avocado Oil" },
            { src: beanCharroClaim3, alt: "High Fiber" },
            { src: beanCharroClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JYCVD2?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "bean_mexican_black",
        name: "Mexican Black Beans",
        category: PRODUCT_CATEGORIES.BEANS,
        description: "Rich Mexican black beans cooked low and slow.",
        price: "$29.99",
        imageSrc: beanMexicanBlackImg,
        imageAlt: "Mexican Black Beans",
        backgroundColor: "#511011",
        backgroundDesign: 3,
        images: [
            beanMexicanBlackImg3,
            beanMexicanBlackImg,
            beanMexicanBlackImg2,
            beanMexicanBlackImg4,
            beanMexicanBlackImg5,
        ],
        claims: [
            { src: beanMexicanBlackClaim1, alt: "Non-GMO Verified" },
            { src: beanMexicanBlackClaim2, alt: "Avocado Oil" },
            { src: beanMexicanBlackClaim3, alt: "High Fiber" },
            { src: beanMexicanBlackClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JMRMZQ?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "bean_elote_pinto_black",
        name: "Mexican Elote Style Pinto & Black Beans",
        category: PRODUCT_CATEGORIES.BEANS,
        description: "Whole beans mixed with sweet corn and jalapeño for a Mexican street-corn flavor.",
        price: "$29.99",
        imageSrc: beanEloteImg,
        imageAlt: "Mexican Elote Style Pinto & Black Beans",
        backgroundColor: "#F8A716",
        backgroundDesign: 3,
        images: [
            beanEloteImg3,
            beanEloteImg,
            beanEloteImg2,
            beanEloteImg4,
            beanEloteImg5,
        ],
        claims: [
            { src: beanEloteClaim1, alt: "Non-GMO Verified" },
            { src: beanEloteClaim2, alt: "Avocado Oil" },
            { src: beanEloteClaim3, alt: "High Fiber" },
            { src: beanEloteClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JNM145?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "bean_refried_pinto",
        name: "Refried Pinto Beans with Jalapeño",
        category: PRODUCT_CATEGORIES.BEANS,
        description: "Smooth ranchero beans with smoky chipotle heat.",
        price: "$29.99",
        imageSrc: beanRefriedPintoImg,
        imageAlt: "Refried Pinto Beans with Jalapeño",
        backgroundColor: "#6C9336",
        backgroundDesign: 3,
        images: [
            beanRefriedPintoImg3,
            beanRefriedPintoImg,
            beanRefriedPintoImg2,
            beanRefriedPintoImg4,
            beanRefriedPintoImg5,
        ],
        claims: [
            { src: beanRefriedPintoClaim1, alt: "Non-GMO Verified" },
            { src: beanRefriedPintoClaim2, alt: "Avocado Oil" },
            { src: beanRefriedPintoClaim3, alt: "High Fiber" },
            { src: beanRefriedPintoClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "bean_refried_ranchero",
        name: "Refried Ranchero Beans with Chipotle",
        category: PRODUCT_CATEGORIES.BEANS,
        description: "Smooth ranchero beans with smoky chipotle heat.",
        price: "$29.99",
        imageSrc: beanRefriedRancheroImg,
        imageAlt: "Refried Ranchero Beans with Chipotle",
        backgroundColor: "#C3852C",
        backgroundDesign: 3,
        images: [
            beanRefriedRancheroImg3,
            beanRefriedRancheroImg,
            beanRefriedRancheroImg2,
            beanRefriedRancheroImg4,
            beanRefriedRancheroImg5,
        ],
        claims: [
            { src: beanRefriedRancheroClaim1, alt: "Non-GMO Verified" },
            { src: beanRefriedRancheroClaim2, alt: "Avocado Oil" },
            { src: beanRefriedRancheroClaim3, alt: "High Fiber" },
            { src: beanRefriedRancheroClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "",
        productSellingDescription: "6-POUCH PACK"
    },

    // RICE CUPS
    {
        id: "rice_cup_mexican_homestyle",
        name: "Mexican Homestyle Red Rice Cup",
        category: PRODUCT_CATEGORIES.RICE_CUPS,
        description: "Rich, mexican red rice that tastes just like home.",
        price: "$0.00",
        imageSrc: riceCupMexicanHomestyleImg,
        imageAlt: "Mexican Homestyle Red Rice Cup",
        backgroundColor: "#7F1535",
        backgroundDesign: 2,
        images: [
            riceCupMexicanHomestyleImg,
            riceCupMexicanHomestyleImg2,
            riceCupMexicanHomestyleImg3,
        ],
        claims: [
            { src: riceCupMexicanHomestyleClaim1, alt: "Bone Broth" },
            { src: riceCupMexicanHomestyleClaim2, alt: "Avocado Oil" },
            { src: riceCupMexicanHomestyleClaim3, alt: "Pantry Stable" },
            { src: riceCupMexicanHomestyleClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "",
        productSellingDescription: ""
    },
    {
        id: "rice_cup_mexican_pollo_asado",
        name: "Mexican Pollo Asado Rice Cup",
        category: PRODUCT_CATEGORIES.RICE_CUPS,
        description: "Mexican roasted chicken flavor cooked in bone broth for no empty calories.",
        price: "$0.00",
        imageSrc: riceCupMexicanPolloAsadoImg,
        imageAlt: "Mexican Pollo Asado Rice Cup",
        backgroundColor: "#945511",
        backgroundDesign: 2,
        images: [
            riceCupMexicanPolloAsadoImg,
            riceCupMexicanPolloAsadoImg2,
            riceCupMexicanPolloAsadoImg3,
        ],
        claims: [
            { src: riceCupMexicanPolloAsadoClaim1, alt: "Bone Broth" },
            { src: riceCupMexicanPolloAsadoClaim2, alt: "Avocado Oil" },
            { src: riceCupMexicanPolloAsadoClaim3, alt: "Pantry Stable" },
            { src: riceCupMexicanPolloAsadoClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1N17W5K?ref_=ast_sto_dp&th=1",
        productSellingDescription: ""
    },
    {
        id: "rice_cup_street_corn",
        name: "Mexican Street Corn Rice Cup",
        category: PRODUCT_CATEGORIES.RICE_CUPS,
        description: "Smoky, savory street-corn rice that tastes like a comfort meal.",
        price: "$0.00",
        imageSrc: riceCupMexicanStreetCornImg,
        imageAlt: "Mexican Street Corn Rice Cup",
        backgroundColor: "#C3852C",
        backgroundDesign: 2,
        images: [
            riceCupMexicanStreetCornImg,
            riceCupMexicanStreetCornImg2,
            riceCupMexicanStreetCornImg3,
        ],
        claims: [
            { src: riceCupMexicanStreetCornClaim1, alt: "Bone Broth" },
            { src: riceCupMexicanStreetCornClaim2, alt: "Avocado Oil" },
            { src: riceCupMexicanStreetCornClaim3, alt: "Pantry Stable" },
            { src: riceCupMexicanStreetCornClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JTMTLT?ref_=ast_sto_dp&th=1",
        productSellingDescription: ""
    },
    {
        id: "rice_cup_peppers_chipotle",
        name: "Peppers & Chipotle Rice Cup",
        category: PRODUCT_CATEGORIES.RICE_CUPS,
        description: "Smoky chipotle and roasted peppers for a big, spicy flavor kick.",
        price: "$0.00",
        imageSrc: riceCupPeppersChipotleImg,
        imageAlt: "Peppers & Chipotle Rice Cup",
        backgroundColor: "#511011",
        backgroundDesign: 2,
        images: [
            riceCupPeppersChipotleImg,
            riceCupPeppersChipotleImg2,
            riceCupPeppersChipotleImg3,
        ],
        claims: [
            { src: riceCupPeppersChipotleClaim1, alt: "Bone Broth" },
            { src: riceCupPeppersChipotleClaim2, alt: "Avocado Oil" },
            { src: riceCupPeppersChipotleClaim3, alt: "Pantry Stable" },
            { src: riceCupPeppersChipotleClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1MW187V?ref_=ast_sto_dp&th=1",
        productSellingDescription: ""
    },
    {
        id: "rice_cup_poblano",
        name: "Poblano Rice Cup with Corn",
        category: PRODUCT_CATEGORIES.RICE_CUPS,
        description: "Creamy roasted poblano and sweet corn cooked in bone broth.",
        price: "$0.00",
        imageSrc: riceCupPoblanoImg,
        imageAlt: "Poblano Rice Cup with Corn",
        backgroundColor: "#6C9336",
        backgroundDesign: 2,
        images: [
            riceCupPoblanoImg,
            riceCupPoblanoImg2,
            riceCupPoblanoImg3,
        ],
        claims: [
            { src: riceCupPoblanoClaim1, alt: "Bone Broth" },
            { src: riceCupPoblanoClaim2, alt: "Avocado Oil" },
            { src: riceCupPoblanoClaim3, alt: "Pantry Stable" },
            { src: riceCupPoblanoClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1N2C3MP?ref_=ast_sto_dp&th=1",
        productSellingDescription: ""
    },

    // RICE POUCHES
    {
        id: "rice_pouch_mexican_homestyle",
        name: "Mexican Homestyle Red Rice Pouch",
        category: PRODUCT_CATEGORIES.RICE_POUCH,
        description: "Rich, mexican red rice that tastes just like home.",
        price: "$29.99",
        imageSrc: ricePouchMexicanHomestyleImg,
        imageAlt: "Mexican Homestyle Red Rice Pouch",
        backgroundColor: "#7F1535",
        backgroundDesign: 2,
        images: [
            ricePouchMexicanHomestyleImg3,
            ricePouchMexicanHomestyleImg,
            ricePouchMexicanHomestyleImg2,
            ricePouchMexicanHomestyleImg4,
            ricePouchMexicanHomestyleImg5,
        ],
        claims: [
            { src: ricePouchMexicanHomestyleClaim1, alt: "Bone Broth" },
            { src: ricePouchMexicanHomestyleClaim2, alt: "Avocado Oil" },
            { src: ricePouchMexicanHomestyleClaim3, alt: "Pantry Stable" },
            { src: ricePouchMexicanHomestyleClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JTR3C8?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "rice_pouch_mexican_pollo_asado",
        name: "Mexican Pollo Asado Rice Pouch",
        category: PRODUCT_CATEGORIES.RICE_POUCH,
        description: "Mexican roasted chicken flavor cooked in bone broth for no empty calories.",
        price: "$29.99",
        imageSrc: ricePouchMexicanPolloAsadoImg,
        imageAlt: "Mexican Pollo Asado Rice Pouch",
        backgroundColor: "#945511",
        backgroundDesign: 2,
        images: [
            ricePouchMexicanPolloAsadoImg3,
            ricePouchMexicanPolloAsadoImg,
            ricePouchMexicanPolloAsadoImg2,
            ricePouchMexicanPolloAsadoImg4,
            ricePouchMexicanPolloAsadoImg5,
        ],
        claims: [
            { src: ricePouchMexicanPolloAsadoClaim1, alt: "Bone Broth" },
            { src: ricePouchMexicanPolloAsadoClaim2, alt: "Avocado Oil" },
            { src: ricePouchMexicanPolloAsadoClaim3, alt: "Pantry Stable" },
            { src: ricePouchMexicanPolloAsadoClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JTZZR1?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "rice_pouch_mexican_street_corn",
        name: "Mexican Street Corn Rice Pouch",
        category: PRODUCT_CATEGORIES.RICE_POUCH,
        description: "Smoky, savory street-corn rice that tastes like a comfort meal.",
        price: "$29.99",
        imageSrc: ricePouchMexicanStreetCornImg,
        imageAlt: "Mexican Street Corn Rice Pouch",
        backgroundColor: "#C3852C",
        backgroundDesign: 2,
        images: [
            ricePouchMexicanStreetCornImg3,
            ricePouchMexicanStreetCornImg,
            ricePouchMexicanStreetCornImg2,
            ricePouchMexicanStreetCornImg4,
            ricePouchMexicanStreetCornImg5,
        ],
        claims: [
            { src: ricePouchMexicanStreetCornClaim1, alt: "Bone Broth" },
            { src: ricePouchMexicanStreetCornClaim2, alt: "Avocado Oil" },
            { src: ricePouchMexicanStreetCornClaim3, alt: "Pantry Stable" },
            { src: ricePouchMexicanStreetCornClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JYJKCX?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "rice_pouch_peppers_chipotle",
        name: "Peppers & Chipotle Rice Pouch",
        category: PRODUCT_CATEGORIES.RICE_POUCH,
        description: "Smoky chipotle and roasted peppers for a big, spicy flavor kick.",
        price: "$29.99",
        imageSrc: ricePouchPeppersChipotleImg,
        imageAlt: "Peppers & Chipotle Rice Pouch",
        backgroundColor: "#511011",
        backgroundDesign: 2,
        images: [
            ricePouchPeppersChipotleImg3,
            ricePouchPeppersChipotleImg,
            ricePouchPeppersChipotleImg2,
            ricePouchPeppersChipotleImg4,
            ricePouchPeppersChipotleImg5,
        ],
        claims: [
            { src: ricePouchPeppersChipotleClaim1, alt: "Bone Broth" },
            { src: ricePouchPeppersChipotleClaim2, alt: "Avocado Oil" },
            { src: ricePouchPeppersChipotleClaim3, alt: "Pantry Stable" },
            { src: ricePouchPeppersChipotleClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JNMCSB?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "rice_pouch_poblano",
        name: "Poblano Rice with Corn Rice Pouch",
        category: PRODUCT_CATEGORIES.RICE_POUCH,
        description: "Creamy roasted poblano and sweet corn cooked in bone broth.",
        price: "$29.99",
        imageSrc: ricePouchPoblanoImg,
        imageAlt: "Poblano Rice with Corn Rice Pouch",
        backgroundColor: "#6C9336",
        backgroundDesign: 2,
        images: [
            ricePouchPoblanoImg3,
            ricePouchPoblanoImg,
            ricePouchPoblanoImg2,
            ricePouchPoblanoImg4,
            ricePouchPoblanoImg5,
        ],
        claims: [
            { src: ricePouchPoblanoClaim1, alt: "Bone Broth" },
            { src: ricePouchPoblanoClaim2, alt: "Avocado Oil" },
            { src: ricePouchPoblanoClaim3, alt: "Pantry Stable" },
            { src: ricePouchPoblanoClaim4, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Mexican/dp/B0H1JV9DRB?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },

    // TAMALES
    {
        id: "tamale_green_salsa",
        name: "Green Salsa Tamale",
        category: PRODUCT_CATEGORIES.TAMALES,
        description: "Fresh green salsa and soft masa that hits the spot every time.",
        price: "$29.99",
        imageSrc: tamaleGreenSalsa,
        imageAlt: "Green Salsa Tamale",
        backgroundColor: "#6C9336",
        backgroundDesign: 1,
        images: [
            tamaleGreenSalsa3,
            tamaleGreenSalsa,
            tamaleGreenSalsa2,
            tamaleGreenSalsa4,
            tamaleGreenSalsa5,
        ],
        claims: [
            { src: tamaleGreenSalsaClaim1, alt: "High Protein" },
            { src: tamaleGreenSalsaClaim2, alt: "Beef Tallow" },
            { src: tamaleGreenSalsaClaim3, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Authentic/dp/B0H1JCKJK4?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "tamale_red_salsa",
        name: "Red Salsa Tamale",
        category: PRODUCT_CATEGORIES.TAMALES,
        description: "Bold red salsa and tender masa, the classic you always crave.",
        price: "$29.99",
        imageSrc: tamaleRedSalsa,
        imageAlt: "Red Salsa Tamale",
        backgroundColor: "#B8231E",
        backgroundDesign: 1,
        images: [
            tamaleRedSalsa3,
            tamaleRedSalsa,
            tamaleRedSalsa2,
            tamaleRedSalsa4,
            tamaleRedSalsa5,
        ],
        claims: [
            { src: tamaleRedSalsaClaim1, alt: "High Protein" },
            { src: tamaleRedSalsaClaim2, alt: "Beef Tallow" },
            { src: tamaleRedSalsaClaim3, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Authentic/dp/B0H1JL5VHP?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
    {
        id: "tamale_street_corn",
        name: "Mexican Street Corn Tamale",
        category: PRODUCT_CATEGORIES.TAMALES,
        description: "Sweet corn, jalapeño, and creamy flavor in every warm, tasty bite.",
        price: "$29.99",
        imageSrc: tamaleStreetCorn,
        imageAlt: "Mexican Street Corn Tamale",
        backgroundColor: "#F8A716",
        backgroundDesign: 1,
        images: [
            tamaleStreetCorn3,
            tamaleStreetCorn,
            tamaleStreetCorn2,
            tamaleStreetCorn4,
            tamaleStreetCorn5,
        ],
        claims: [
            { src: tamaleStreetCornClaim1, alt: "Seed Oil Free" },
            { src: tamaleStreetCornClaim2, alt: "Beef Tallow" },
            { src: tamaleStreetCornClaim3, alt: "Ready in Seconds" },
        ],
        productLinkUrl: "https://www.amazon.com/San-Miguel-Origen-Protein-Authentic/dp/B0H1JMHBF9?ref_=ast_sto_dp&th=1",
        productSellingDescription: "6-POUCH PACK"
    },
];